import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Row, Col, Input, DatePicker, Button, Select } from "antd";
import { create } from 'kts-scaffold-framework/utils/form';
 
const css = require('./index.scss');
const FormItem = Form.Item;
const Option = Select.Option;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    id?: number;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class DetailFilter extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    handleReset = () => {
        // this.props.clearFields();
        this.props.form.resetFields();
    }
    toggle = () => {
        const { expand } = this.state;
        this.setState({ expand: !expand });
    }
    
    handleFilter = e => {
        e.preventDefault();
        // const { companyInfo, id } = this.state;
        this.props.form.validateFields((err, values) => {
            let data = {
                ...values,
                // currentPage: 1,
            };
            let queryData ={
                compareBachId: this.props.id,
                pageNumber: 1,
                pageSize: 10
            };
            let filterData ={...values, ...queryData};
            this.modulesState.detailFields = values;
            this.setModulesState();
            ModulesAction.getDetail(filterData);
        });
    }
    render() {
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };
        const { getFieldDecorator } = this.props.form;
        return (
            <Form onSubmit={this.handleFilter}>
            <Row style={{marginTop:12, marginBottom: 12}}>
                <Col span={8}>
                    <FormItem label={`发票代码`} {...formItemLayout}>
                        {getFieldDecorator("invoiceCode", {
                            rules: [
                                {
                                    message: "请输入号码（只支持数字)",
                                    pattern: /^[0-9]*$/,
                                }
                            ]
                        })(
                            <Input 
                                type="text" 
                                placeholder="10位或12位发票码"  
                                maxLength={12}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col span={8}>
                    <FormItem label={`发票号码`} {...formItemLayout}>
                        {getFieldDecorator("invoiceNumber",{
                            rules: [
                                {
                                    message: "请输入号码（只支持数字)",
                                    pattern: /^[0-9]*$/,
                                }
                            ]
                        })(
                            <Input 
                                type="text" 
                                placeholder="8位发票号码" 
                                maxLength={8}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col span={8}>
                    <FormItem {...formItemLayout} label={`状态`}>
                        {getFieldDecorator("draft_state")(
                            <Select allowClear={true} >
                                <Option value="1">未勾选提交</Option>
                                <Option value="2">勾选提交成功</Option>
                                <Option value="3">勾选提交失败</Option>
                            </Select>
                        )}
                    </FormItem>
                </Col>
                <Col span={8}>
                    <div style={{marginTop: -10}}>
                    <FormItem {...formItemLayout} label={`上传记录`}>
                        {getFieldDecorator("compareStatus")(
                            <Select allowClear={true} >
                                <Option value="1">仅电子票</Option>
                                <Option value="2">电子票和实体票齐全</Option>
                                <Option value="3">仅实体票</Option>
                            </Select>
                        )}
                    </FormItem>
                    </div>
                </Col>
                <Col span={16}>
                    <div className="pull-right" style={{marginTop: -10}}>

                        <Button
                            className="mr10"
                            onClick={this.handleReset}
                        >
                            清空
                        </Button>
                        <Button type="primary" htmlType="submit">
                            筛选
                        </Button>
                    </div>
                </Col>
            </Row>
        </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceCompare/UI.CompareDetail.Filter.tsx